// Bibliothèque de clauses (Ordre 18 ter) — what the screens need besides the server's answers.
import { BLOCK_GROUPS, blockTexts } from "./records";

// The blocks that make sense INSIDE a contract (D-105) — the server refuses any other kind in a clause.
export const CLAUSE_KINDS = ["heading", "article", "paragraph", "list", "table", "keyvalue", "callout", "separator"];

// The add-a-block menu of the clause editor: the families of the template editor, reduced to what a clause may hold.
export const CLAUSE_GROUPS = BLOCK_GROUPS.map((g) => ({ ...g, kinds: g.kinds.filter((k) => CLAUSE_KINDS.includes(k)) })).filter((g) => g.kinds.length);

// The block a template stores when a clause is inserted: the reference (clause, VERSION) and the frozen copy of that version's content.
export function clauseBlockOf(clause) {
  const version = clause.published;
  return { kind: "clause", clause_id: clause.id, clause_number: version.number, clause_name: clause.name, clause_blocks: version.blocks };
}

// A newer published version exists than the one the template took (D-101: never applied by itself).
export function updateAvailable(block, status) {
  return !!status && Number.isInteger(status.latest_number) && status.latest_number > block.clause_number;
}

// The clause turned into the ordinary blocks of the template (D-102: « Détacher », no link any more).
export function detachAt(blocks, index) {
  const block = blocks[index];
  if (!block || block.kind !== "clause") return blocks;
  return [...blocks.slice(0, index), ...(block.clause_blocks || []), ...blocks.slice(index + 1)];
}

// The text of a clause as lines, for the preview in the card and for the comparison of two versions.
export function clauseLines(blocks) {
  return (blocks || []).flatMap((b) => blockTexts(b).map((text) => ({ kind: b.kind, text })));
}

// Line diff of two versions (longest common subsequence): « same », « del » (only in the old one), « add » (only in the new one).
export function lineDiff(oldLines, newLines) {
  const a = oldLines.map((l) => l.text);
  const b = newLines.map((l) => l.text);
  const table = Array.from({ length: a.length + 1 }, () => new Array(b.length + 1).fill(0));
  for (let i = a.length - 1; i >= 0; i -= 1) {
    for (let j = b.length - 1; j >= 0; j -= 1) table[i][j] = a[i] === b[j] ? table[i + 1][j + 1] + 1 : Math.max(table[i + 1][j], table[i][j + 1]);
  }
  const ops = [];
  let i = 0;
  let j = 0;
  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) { ops.push({ type: "same", text: a[i] }); i += 1; j += 1; }
    else if (table[i + 1][j] >= table[i][j + 1]) { ops.push({ type: "del", text: a[i] }); i += 1; }
    else { ops.push({ type: "add", text: b[j] }); j += 1; }
  }
  while (i < a.length) { ops.push({ type: "del", text: a[i] }); i += 1; }
  while (j < b.length) { ops.push({ type: "add", text: b[j] }); j += 1; }
  return ops;
}

export function changedCount(ops) {
  return ops.filter((o) => o.type !== "same").length;
}

export function themeLabel(themes, code) {
  return themes.find((t) => t.code === code)?.label || code;
}
